import React from 'react';
import E8ReferenceLayout from './E8ReferenceLayout';

const E8ReferenceTool = () => {
  return <E8ReferenceLayout />;
};

export default E8ReferenceTool; 